export default {
  applicant: {
    address1st: null,
    address1stKana: null,
    address2nd: null,
    address2ndKana: null,
    birthAtDay: '',
    birthAtMonth: '',
    birthAtYear: '',
    bloodType: null,
    email: null,
    gender: '1',
    mobile: null,
    nameEn: null,
    nameKana: null,
    nameJa: null,
    postCode: null,
    prefecture: '',
    tel: null,
    visitAtDay: '',
    visitAtMonth: '',
    visitAtYear: '',
  },
  course: {
    id: '',
    rankId: null,
    name: null,
    price: null,
    priceWithTax: null,
  },
  diveCenter: {
    id: '',
    name: '',
    email: '',
    others: '',
    othersEmail: '',
  },
  emergency: {
    address1st: null,
    address1stKana: null,
    address2nd: null,
    address2ndKana: null,
    email: null,
    familyRelationship: null,
    mobile: null,
    name: null,
    nameKana: null,
    postCode: null,
    prefecture: '',
    tel: null,
  },
  rental: {
    height: null,
    opticLeft: null,
    opticRight: null,
    shoeSize: null,
    weight: null,
  },
  requestBodyForRegister: null,
  payBy: null,
  registerResponse: {
    message: null,
    status: null,
    payBy: null,
    redirectUrl: null,
  },
  inputSummary: null,
};
